// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"ed78bc91","161":"d0172b44","506":"37917c52","608":"12b3d5ec","721":"7faa86ec","849":"387bf2c0","886":"6e9559af"}[chunkId] + ".chunk.js";
};